import classnames from 'classnames';
import { resolveStatusLevel, vehicleStatusModifier } from 'helper/vehicleStatus';

import type { SearchedVehicle } from './types';
import VehicleIdentifier from './VehicleIdentifier';

import './styles/Vehicle.scss';

const Vehicle = ({ name, vin, licensePlate, connectivityStatus, severity }: SearchedVehicle) => {
    const level = resolveStatusLevel({ severity, connectivityState: connectivityStatus?.state });
    const modifier = vehicleStatusModifier(level, { foldOnlineToBase: true });

    return (
        <div className='Vehicle'>
            <div
                data-testid='vehicle-status'
                className={classnames('Vehicle__severity', modifier && `Vehicle__severity--${modifier}`)}
            />
            <VehicleIdentifier
                name={name}
                licensePlate={licensePlate}
                vin={vin}
                connectivityState={connectivityStatus?.state}
            />
        </div>
    );
};

export default Vehicle;
